import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const diceRollerTool: Tool = {
  id: "dice-roller",
  name: () => m.dice_tool_name(),
  description: () => m.dice_tool_description(),
  icon: "🎲",
  basePath: "/dice-roller",
  status: "stable",
  tags: ["everyday", "games", "dice", "dice-roller"],
};
